export function getPanelItems(panel) {
    if (!panel) {
        return [];
    }

    return [...panel.querySelectorAll("[role='menuitem']")].filter((el) => {
        return el.closest("[role='menu']") === panel;
    });
}

export function getEnabledItems(panel) {
    return getPanelItems(panel).filter((el) => {
        return el.getAttribute("aria-disabled") !== "true";
    });
}

export function focusItem(el) {
    el?.focus();
}

export function getMenuPanel(trigger) {
    return trigger?.closest(".nav-item")?.querySelector(":scope > [role='menu']");
}

export function isMenuNavigationKey(key) {
    return [
        "ArrowUp",
        "ArrowDown",
        "ArrowLeft",
        "ArrowRight",
        "Escape",
        "Home",
        "End",
        "Enter",
        " ",
        "Tab",
    ].includes(key);
}
